import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Tag } from '../../../../Elements/Tag';
import { InfoTooltipIcon } from '../../../../Feedback/InfoTooltipIcon';
import { TitleWrapper } from './styled';
export const TitleContent = memo(function TitleContent({ title, tooltip, tag }) {
    return (_jsxs(TitleWrapper, { "data-testid": 'title-wrapper', children: [_jsx("span", { children: title }), tooltip && _jsx(InfoTooltipIcon, { tooltip: tooltip, size: 24, dataTestId: 'section-title-tooltip' }), tag && _jsx(Tag, { title: tag })] }));
});
